import React, { useState} from 'react';
import Button from '../../Button/Button';

const ItemPlace = (props) => {
    const [itemClassName, setItemClassName] = useState('Place ' + props.className);

    function AnswerControl() {
        if (props.itemContent.fake) setItemClassName(props.className + ' Wrong');
        else props.onClick('answer');
    }

    return <Button className={itemClassName} value={props.itemContent.words} onClick={AnswerControl} /> 
}

export default ItemPlace;